import Immutable from 'immutable';

import Link from '../../../../../../../common/records/Link';
import NamedLink from '../../../../../../../common/records/NamedLink';
import RotatableEntity from '../../../../../../../common/records/RotatableEntity';
import CategoryContent, {
  AtlassianProductDiversion,
  HeroImage,
  MoreDetails,
  PageMetaDetails,
  UseCases,
} from '../../records/CategoryContent';

export default ({ data }) => {
  const transformViewMoreFilters = viewMoreFilters =>
    Immutable.Map(viewMoreFilters).update(
      'moreFilters',
      filterValue => filterValue && Immutable.Set(filterValue)
    );

  return new CategoryContent({
    name: data.name,
    heroImage: new HeroImage({
      svg: data.heroImage.fields.svg.fields.file.url,
      png: data.heroImage.fields.png.fields.file.url,
    }),
    heading: data.heading,
    tagline: data.tagline,
    primaryDescription: data.primaryDescription,
    appsSectionTitle: data.appsSectionTitle,
    atlassianProductDiversion: data.atlassianProductDiversion
      ? new AtlassianProductDiversion({
          introduction: data.atlassianProductDiversion.fields.introduction,
          productLinks: Immutable.List(data.atlassianProductDiversion.fields.productLinks).map(
            pl =>
              new NamedLink({
                name: pl.fields.linkText,
                link: new Link({
                  href: pl.fields.url,
                }),
              })
          ),
        })
      : undefined,
    moreDetails: new MoreDetails({
      heading: data.moreDetails.fields.heading,
      content: data.moreDetails.fields.content.split('\n'),
      icon: data.moreDetails.fields.icon.fields.file.url,
    }),
    useCases: new UseCases({
      heading: data.useCases.fields.name,
      description: data.useCases.fields.description,
      items: Immutable.List(data.useCases.fields.useCases),
    }),
    callToActionTitle: data.callToActionTitle,
    curatedApps: new RotatableEntity({
      pinned: Immutable.List(data.curatedApps.fields.pinned),
      unpinned: Immutable.List(data.curatedApps.fields.unpinned),
    }),
    viewMoreFilters: transformViewMoreFilters(data.viewMoreFilters),
    preferredHosting: data.preferredHosting,
    viewMoreActionText: data.viewMoreActionText,
    pageMetaDetails: new PageMetaDetails({
      title: data.pageMetaDetails.fields.title,
      description: data.pageMetaDetails.fields.description,
    }),
  });
};
